import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_list_restarea",
  "use": "icon-ic_list_restarea-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"icon-ic_list_restarea\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.89 10.135a8.889 8.889 0 1 1-17.779 0 8.889 8.889 0 0 1 17.778 0Zm-5.557 0-.667-2.222h1.778V6.43H5.555v1.482h1.778l-.666 2.222H4.074v1.481h2.148l-.667 2.223h1.586l.637-2.223h4.444l.637 2.223h1.585l-.666-2.223h2.148v-1.481h-2.593Zm-5.133 0 .637-2.222h2.326l.637 2.222H8.2Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol